// extracted by mini-css-extract-plugin
export default {"BaseLayout":"BaseLayout_BaseLayout__4cjMa"};